




















import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import AppsList from '@/components/AppsList.vue';
import AppEdit from '@/components/AppEdit.vue';
import { Action, Getter } from 'vuex-class';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import AppsService from '@/services/apps.service';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    Dialog,
    SearchBar,
    AppsList,
    AppEdit,
  },
})
export default class Apps extends Vue {

  public application: any = null;
  private showAddEditApplicationDialog: boolean = false;
  private searchNames: string = '';
  private saved: boolean = false;
  private isSaving: boolean = false;
  @Getter private hasPermission: any;

  public mounted() {
    if (!this.hasPermission('administration:view')) {
      this.$router.push('/');
    }
  }

  private async editApplication(app: any) {
    this.application = app && app.id ? app : {name: '', organisations: [], type: ''};
    this.showAddEditApplicationDialog = true;
  }

  private async close() {
    this.showAddEditApplicationDialog = false;

    await (this.$refs.appList as AppsList).loadApplications();

  }
}
